var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.339,
    height: 21.341,
    viewBox: "0 0 17.339 21.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bin",
    "data-name": "Icon metro-bin",
    d: "M5.833,8.6V21.935a1.338,1.338,0,0,0,1.334,1.334h12A1.338,1.338,0,0,0,20.5,21.935V8.6H5.833Zm4,12H8.5V11.265H9.834Zm2.668,0H11.168V11.265H12.5Zm2.668,0H13.835V11.265h1.334Zm2.668,0H16.5V11.265h1.334Zm3-16.006H16.5V2.928a1,1,0,0,0-1-1H10.834a1,1,0,0,0-1,1V4.6H5.5a1,1,0,0,0-1,1V7.263H21.838V5.6a1,1,0,0,0-1-1Zm-5.669,0h-4V3.279h4V4.6Z",
    transform: "translate(-4.499 -1.928)",
    fill: "#db002a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.72abca1e1234e6ca4e3b1302329459a1.svg";
export { ForwardRef as ReactComponent };